import { useParams } from 'react-router-dom';

import { DownloadTab } from '@/components/deploy/download-tab';

export function ProjectDownloadPage() {
  const { projectKey } = useParams<{ projectKey: string }>();
  const key = projectKey ?? '';

  return (
    <main id="main-content" className="mx-auto max-w-5xl">
      <header className="mb-4">
        <h1 className="text-2xl font-bold text-content">Download</h1>
        <p className="mt-1 text-sm text-content-secondary">
          Browse and download artifact versions from CodeArtifact
        </p>
      </header>

      <DownloadTab projectKey={key} />
    </main>
  );
}
